import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import ResetPasswordRoute from '~/features/auth/routes/ResetPassword.route';

export const Route = createFileRoute('/_auth/reset/password/')({
    component: () => <ResetPasswordRoute />,
    validateSearch: z.object({
        jwt: z.string(),
    }),
});
